<template>
    <div>
        <div class="flex items-center justify-between">
            <span :class="{ 'text-error-600 font-bold': dataConfig && data.pricingEstimate.markup < dataConfig.markup && statusApprovalMarkup !== 1 }">
                {{ $formatters.formatCurrency(data.pricingEstimate.markup) }} %
            </span>
            <div v-if="selected">
                <hi-pencil-square-icon class="h-5 w-5 ml-3 text-error-600 hover:text-error-500 cursor-pointer" />
            </div>
        </div>
    <!--
      <div v-if="dataConfig && typeof dataConfig.markup === 'number' && (data?.pricingEstimate?.markup || 0) < (dataConfig?.markup || 0)">
      <span class="label-text text-error-500">
      Markup phải lớn hơn hoặc bằng {{ $formatters.formatCurrency(dataConfig?.markup) }}
      </span>
      </div>
    -->
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)
const { $formatters } = useNuxtApp()

const data = computed(() => params?.value?.node?.data || null)

const selected = computed(() => params?.value?.node?.selected || null)
const dataConfig = computed(() => {
  if (typeof params?.value?.dataConfig === 'function') {
    return params?.value?.dataConfig()
  }
  return params?.value?.dataConfig || null
})

const statusApprovalMarkup = computed(() => params?.value?.statusApprovalMarkup())
</script>

<style scoped></style>
